export default __webpack_public_path__ + "static/media/sunburst.84abcf47.mp4";